import { ExceptionInfo, exceptionData, exceptionMessage } from './common/types.ts';
import type { ReasonUri } from './common/types/messages.ts';

export type Reason = { uri: ReasonUri, message: string };

export function reason(uri: ReasonUri, message: string): Reason {
    return {uri, message};
}

export function exceptionToReason(ex: unknown, defaultUri: string): Reason {
    const r = exceptionData(ex);
    return {uri: r?.uri ?? defaultUri, message: r?.message ?? exceptionMessage(ex) ?? ''};
}

export function throwReason(uri: ReasonUri, message: string): never {
    const reason: Reason = {uri, message};
    throw new ExceptionInfo(message, reason);
}

export function requestToReason(request: {reason_uri: ReasonUri, reason: string}): Reason {
    return {uri: request.reason_uri, message: request.reason};
}
